import EmberObject, { get } from "@ember/object"
import { inject as service } from "@ember/service"
import ENV from "../config/environment"

export default class UserSummaryAdapter extends EmberObject {
  @service
  ajax

  find(ids) {
    return get(this, "ajax").requestFromAdapter(ENV.API_ROOT + "/user_summaries/" + ids.join(","))
  }
}
